import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import formatter from './formatter';
import { options } from '../utility/options';
import enTranslation from './languages/en/translation.json';
import deTranslation from './languages/de/translation.json';

export const supportedLngs = {
  en: "English",
  de: "Deutsch",
};

i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      de: { translation: deTranslation },
    },
    fallbackLng: 'en',
    supportedLngs: Object.keys(supportedLngs),
    debug: options.environment === 'development',
    interpolation: { escapeValue: false },
    saveMissing: true
  });



Object.entries(formatter).forEach(([key, resolver]) => {
  i18next.services.formatter?.add(key, resolver);
});

export default i18next;
